import { styled, css } from 'styled-components';
import { Text } from '../Text';
import { breakpoints, getFontSize, getFontWeight } from '../../abstracts';
const animationMaxWidth = {
  md: '512px',
  lg: '665px'
};
export const Container = styled.main.withConfig({
  componentId: "aui__sc-8yrtcs-0"
})(["display:flex;flex-direction:column;align-items:center;white-space:pre-wrap;text-align:center;position:relative;min-height:100vh;margin:2.5rem 1rem 0;color:var(--aui-on-surface);& > a,& > button{margin-top:1.5rem;}"]);
export const Title = styled(Text).attrs({
  as: 'h1'
}).withConfig({
  componentId: "aui__sc-8yrtcs-1"
})(["padding:0;margin:0;font-size:", ";font-weight:", ";line-height:120%;", "{font-size:", ";line-height:110%;}", "{font-size:", ";line-height:105%;}", "{font-size:", ";}"], getFontSize(5), getFontWeight('feather'), breakpoints.md, getFontSize(7), breakpoints.lg, getFontSize(7), breakpoints.xl, getFontSize(8));
export const Subtitle = styled(Text).withConfig({
  componentId: "aui__sc-8yrtcs-2"
})(["margin:0.5rem 0 1.5rem;font-size:", ";font-weight:", ";line-height:130%;", "{font-size:", ";font-weight:", ";margin:1rem 0 0.5rem;}", "{line-height:120%;}", "{font-size:", ";margin-bottom:0.25rem;}"], getFontSize(2), getFontWeight('base'), breakpoints.md, getFontSize(4), getFontWeight('feather'), breakpoints.lg, breakpoints.xl, getFontSize(5));
export const AnimationContainer = styled.div.withConfig({
  componentId: "aui__sc-8yrtcs-3"
})(["position:relative;width:100%;display:flex;align-items:center;justify-content:center;"]);
const frameStyles = css(["width:100%;max-width:", ";", "{max-width:", ";}"], animationMaxWidth.md, breakpoints.xl, animationMaxWidth.lg);
export const ErrorNumber = styled.img.withConfig({
  componentId: "aui__sc-8yrtcs-4"
})(["", " position:relative;background-color:white;z-index:-1;"], frameStyles);
export const Illustration = styled.img.withConfig({
  componentId: "aui__sc-8yrtcs-5"
})(["", ";"], frameStyles);
export const AnimationFrame = styled.img.withConfig({
  componentId: "aui__sc-8yrtcs-6"
})(["", ";position:absolute;"], frameStyles);
export const AnimationImg = styled.img.withConfig({
  componentId: "aui__sc-8yrtcs-7"
})(["position:absolute;z-index:-1;", ""], frameStyles);